// Client lib imports
const businessEvents = require('client/lib/business-events')

// Action types

const DOWNLOAD_SELECT = 'SMS_MODAL_DOWNLOAD_SELECTED'
const HIDE = 'SMS_MODAL_HIDE'
const SHOW = 'SMS_MODAL_SHOW'
const SUBMIT_FAILED = 'SMS_MODAL_SUBMIT_FAILED'
const SUBMIT_SUCCESS = 'SMS_MODAL_SUBMIT_LOADED'
// Action dispatchers

function hide() {
  return {
    type: HIDE
  }
}

function show(payload) {
  return async function (dispatch) {
    await businessEvents.trackSegment('into-sms-modal-view')
    dispatch({
      type: SHOW,
      payload
    })
  }
}

function showDownloadSelected() {
  return async function (dispatch) {
    dispatch({
      type: DOWNLOAD_SELECT
    })
  }
}

function showSubmitError() {
  return async function (dispatch) {
    await businessEvents.trackSegment('into-sms-modal-fail')
    dispatch({
      type: SUBMIT_FAILED
    })
  }
}

function showSubmitSuccess() {
  return async function (dispatch) {
    await businessEvents.trackSegment('into-sms-modal-submit')
    dispatch({
      type: SUBMIT_SUCCESS
    })
  }
}

module.exports = {
  // Action types
  DOWNLOAD_SELECT,
  HIDE,
  SHOW,
  SUBMIT_FAILED,
  SUBMIT_SUCCESS,
  // Action dispatchers
  hide,
  show,
  showDownloadSelected,
  showSubmitError,
  showSubmitSuccess
}
